
import defaultLayout from '../../config/templates/layouts/default.json';
import { setFetchDefaults } from '../actions/entities/io';
import { loadBook } from './../../redux/helpers/loadBook';
import { loadSpineDefaults } from '../actions/entities/cover';


import {
  loadLayouts,
  setIsActiveLayout,
} from '../actions/entities/layouts';

import {
  setLayoutToActivePage,
  setIsActive,
  createPage,
  addCoverToPage,
} from '../actions/entities/pages';

import {

  getDomain,

} from './getParams';

import {
  addContext,
} from '../actions/bookproperties';

import {
  configExist,
  showAlertModal,
} from './';


export function setFirstLayout(store, layoutId, pageId) {
  store.dispatch(addCoverToPage(pageId));
  store.dispatch(setLayoutToActivePage(layoutId, pageId));
  store.dispatch(setIsActiveLayout(layoutId));
  store.dispatch(loadSpineDefaults());
  store.dispatch(setFetchDefaults());
  store.dispatch(setIsActive(pageId));
}


export function loadDefaultState(store, bookId = false, autoFill = false, bookContext, lang) {
  for (const layout of defaultLayout.items) {
    store.dispatch(loadLayouts(layout.layouts));
  }
  const referer = getDomain();

  const page = {
    layout: 0,
    placeholders: [],
    order: 0,
    isActive: false,
  };
  store.dispatch(createPage(page));

  // set first layout to first page
  const [layoutId] = store.getState().entities.layouts.allIds.slice(0, 1);
  const [pageId] = store.getState().entities.pages.allIds.slice(0, 1);
  setFirstLayout(store, layoutId, pageId);

  // Load book properties

  const editorJSON = configExist('getStateUrl', referer);
  fetch(`${editorJSON}/${bookId}/editorjson`, {
    cors: 'no-cors',
    credentials: 'include',
  })
    .then(response => response.json())
    .then((data) => {
      if ('error' in data) {
        return showAlertModal(lang.title_notice, lang.authentication_required);
      }

      const coverSize = data.json.bookProperties.cover.margins;
      store.dispatch(loadBook(coverSize, store, lang));
      store.dispatch(addContext(bookContext));
    });
}



// WEBPACK FOOTER //
// ./src/redux/helpers/loadDefaulState.js